/**
 * Client API dla farmasterowych grup produktow.
 *
 * Backend: `GET/POST/PATCH/PUT/DELETE /api/product-groups[/{id}[/items]]`
 * (handlery w `backend/shared/src/routes/product_groups.rs`).
 */

import { apiFetch } from "@/lib/auth-api";
import type {
	CreateProductGroupPayload,
	DeleteResponse,
	ProductGroupDetail,
	ProductGroupSummary,
	SetItemsPayload,
	SetItemsResponse,
	UpdateProductGroupPayload,
} from "./types";

export const productGroupsApi = {
	list: () => apiFetch<ProductGroupSummary[]>("/product-groups"),

	get: (id: number) => apiFetch<ProductGroupDetail>(`/product-groups/${id}`),

	create: (payload: CreateProductGroupPayload) =>
		apiFetch<ProductGroupDetail>("/product-groups", {
			method: "POST",
			body: JSON.stringify(payload),
		}),

	update: (id: number, payload: UpdateProductGroupPayload) =>
		apiFetch<ProductGroupDetail>(`/product-groups/${id}`, {
			method: "PATCH",
			body: JSON.stringify(payload),
		}),

	setItems: (id: number, payload: SetItemsPayload) =>
		apiFetch<SetItemsResponse>(`/product-groups/${id}/items`, {
			method: "PUT",
			body: JSON.stringify(payload),
		}),

	delete: (id: number) =>
		apiFetch<DeleteResponse>(`/product-groups/${id}`, {
			method: "DELETE",
		}),
};
